import { render, staticRenderFns } from "./wxopenbtn.vue?vue&type=template&id=e86636e6&scoped=true&"
import script from "./wxopenbtn.vue?vue&type=script&lang=js&"
export * from "./wxopenbtn.vue?vue&type=script&lang=js&"
import style0 from "./wxopenbtn.vue?vue&type=style&index=0&id=e86636e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86636e6",
  null
  
)

export default component.exports